import { serverUrl } from "./temp";

/**
 * Student Record
 */
export const studentrecordColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "center_id",
    headerName: "Center Id",
    width: 230,
  },
  {
    field: "student_id",
    headerName: "Student Id",
    width: 230,
  },
  {
    field: "file",
    headerName: "Report Card",
    width: 230,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <img src={params.value} alt="Profile" className="cellImg" />
        </div>
      );
    },
  },
  {
    field: "description",
    headerName: "Description",
    width: 230,
  },
  {
    field: "date",
    headerName: "Date",
    width: 230,
  },
  {
    field: "status",
    headerName: "Status",
    width: 160,
    renderCell: (params) => {
      return (
        <div className={`cellWithStatus ${params.row.status}`}>
          {params.row.status}
        </div>
      );
    },
  },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchStudentrecordRows = async () => {
  try {
    const apiUrl = `${serverUrl}/srecord`;
    const response = await fetch(apiUrl);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
};

// Export an empty array to be used until the API data is loaded
export const studentrecordRows = [];

/**
 * Account
 */
export const accountColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "name",
    headerName: "Account Name",
    width: 230,
  },
  {
    field: "balance",
    headerName: "Account Balance",
    width: 230,
  },
  // {
  //   field: "bank_id",
  //   headerName: "Bank Id",
  //   width: 230,
  // },
  // {
  //   field: "amount",
  //   headerName: "Amount",
  //   width: 230,
  // },
  // {
  //   field: "transaction_id",
  //   headerName: "Transaction Id",
  //   width: 230,
  // },
  // {
  //   field: "transaction_type",
  //   headerName: "Transaction Type",
  //   width: 230,
  // },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchAccountRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    role: "user",
    role_id: localStorage.getItem("role_id"),
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/account`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};

// Export an empty array to be used until the API data is loaded
export const accountRows = [];

/**
 * Expense
 */
export const expenseColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "user_names",
    headerName: "User",
    width: 230,
  },
  {
    field: "account_names",
    headerName: "Account Name",
    width: 230,
  },
  {
    field: "transaction_names",
    headerName: "Transaction",
    width: 230,
  },
  {
    field: "description",
    headerName: "Description",
    width: 230,
  },
  {
    field: "amount",
    headerName: "Amount",
    width: 230,
  },
  {
    field: "balances",
    headerName: "Balance",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchExpenseRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    role: "user",
    role_id: localStorage.getItem("role_id"),
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/expense`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};

// Export an empty array to be used until the API data is loaded
export const expenseRows = [];

/**
 * Users
 */
export const userColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "name",
    headerName: "Name",
    width: 230,
  },
  {
    field: "email",
    headerName: "Email",
    width: 230,
  },
  {
    field: "phone_no",
    headerName: "Phone Number",
    width: 230,
  },
  {
    field: "role_names",
    headerName: "Role",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchUserRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    role: "user",
    role_id: localStorage.getItem("role_id"),
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const userRows = [];

export const cooColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "name",
    headerName: "Name",
    width: 230,
  },
  {
    field: "email",
    headerName: "Email",
    width: 230,
  },
  {
    field: "phone_no",
    headerName: "Phone Number",
    width: 230,
  },
  {
    field: "role_names",
    headerName: "Role",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchCooRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    role: "coo",
    role_id: localStorage.getItem("role_id"),
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const cooRows = [];

/**
 * Class
 */
export const classColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "name",
    headerName: "Name",
    width: 230,
  },
  {
    field: "total_students",
    headerName: "Total Students",
    width: 230,
  },
  // {
  //   field: "subject_names",
  //   headerName: "Subjects",
  //   width: 230,
  // },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchClassRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    role: "coo",
    role_id: "2",
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/class`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const classRows = [];

/**
 * Batch
 */
export const batchColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "name",
    headerName: "Name",
    width: 230,
  },
  {
    field: "year",
    headerName: "Year",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchBatchRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    role: "coo",
    role_id: "2",
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/batch`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const batchRows = [];

/**
 * Duty
 */
export const dutyColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "user_names",
    headerName: "User Id",
    width: 230,
  },
  {
    field: "job",
    headerName: "Job",
    width: 230,
  },
  {
    field: "date",
    headerName: "date",
    width: 230,
  },
  {
    field: "duty_time",
    headerName: "time",
    width: 230,
  },
  {
    field: "description",
    headerName: "Description",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchDutyRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    role_id: localStorage.getItem("role_id"),
    user_id: localStorage.getItem("user_id"),
    // role: 'coo',
    // role_id: '2',
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/duty`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const dutyRows = [];

/**
 * Duty
 */
export const ciColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "user_name",
    headerName: "User",
    width: 230,
  },
  {
    field: "class_name",
    headerName: "Class",
    width: 230,
  },
  // {
  //   field: "date",
  //   headerName: "date",
  //   width: 230,
  // },
  // {
  //   field: "ci_time",
  //   headerName: "time",
  //   width: 230,
  // },
  // {
  //   field: "description",
  //   headerName: "Description",
  //   width: 230,
  // },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchCiRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    // role_id: localStorage.getItem("role_id"),
    // user_id: localStorage.getItem("user_id"),
    // role: 'coo',
    // role_id: '2',
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/ci`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const ciRows = [];

/**
 * Duty
 */
export const groupColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "batch_names",
    headerName: "Batch",
    width: 230,
  },
  {
    field: "class_names",
    headerName: "Class",
    width: 230,
  },
  {
    field: "subject_names",
    headerName: "Subjects",
    width: 230,
  },
  {
    field: "name",
    headerName: "Group Name",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchGroupRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    // role: 'coo',
    // role_id: '2',
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/group`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const groupRows = [];

/**
 * Student
 */
export const studentColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "image_url",
    headerName: "Student Picture",
    width: 230,
    // renderCell: (params) => {
    //   return (
    //     <div className="cellWithImg">
    //       <img src={params.value} alt="public\images.png" className="cellImg" />
    //     </div>
    //   );
    renderCell: (params) => {
      // Handle missing images with fallback
      const handleImageError = (e) => {
        e.target.src = "/images.png";
        e.target.onerror = null; // Prevent infinite loop
      };

      return (
        <div className="cellWithImg">
          <img
            src={params.value || "public/images.png"}
            alt="Profile"
            className="cellImg"
            onError={handleImageError}
          />
        </div>
      );
    },
  },
  {
    field: "name",
    headerName: "Name",
    width: 230,
  },
  {
    field: "phone",
    headerName: "Phone Number",
    width: 230,
  },
  {
    field: "bform_number",
    headerName: "Student Bform Number",
    width: 230,
  },
  {
    field: "father_name",
    headerName: "Father Name",
    width: 230,
  },
  {
    field: "father_phone",
    headerName: "Father Phone Number",
    width: 230,
  },
  {
    field: "father_cnic",
    headerName: "Father CNIC Number",
    width: 230,
  },

  {
    field: "email",
    headerName: "Email",
    width: 230,
  },
  {
    field: "address",
    headerName: "Address",
    width: 230,
  },
  {
    field: "bform_url",
    headerName: "B Form",
    width: 230,
    renderCell: (params) => {
      const fileUrl = params.value;
      const isPDF = fileUrl?.toLowerCase().endsWith(".pdf");

      return (
        <div className="cellWithImg">
          {isPDF ? (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <img
                src="/images/pdf_icon.png" // Replace with your PDF icon path
                alt="PDF"
                style={{ width: "24px", height: "24px" }}
              />
              <span>{fileUrl.split("/").pop()}</span>
            </div>
          ) : (
            <img src={fileUrl} alt="B Form" className="cellImg" />
          )}
        </div>
      );
    },
  },
  {
    field: "roll_no",
    headerName: "Roll No",
    width: 230,
  },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "batch_names",
    headerName: "Batch",
    width: 230,
  },
  {
    field: "class_names",
    headerName: "Class",
    width: 230,
  },
  {
    field: "group_names",
    headerName: "Group",
    width: 230,
  },
  {
    field: "description",
    headerName: "About Student",
    width: 230,
  },
  {
    field: "ref_name",
    headerName: "Reference Name",
    width: 230,
  },
  {
    field: "ref_phone_no",
    headerName: "Reference Phone Number",
    width: 230,
  },
  {
    field: "last_class",
    headerName: "Last Class Attended",
    width: 230,
  },
  {
    field: "last_grade",
    headerName: "Last Grade",
    width: 230,
  },
  {
    field: "percentage",
    headerName: "Last Percentage",
    width: 230,
  },
  {
    field: "marksheet_url",
    headerName: "Last Result Marksheet",
    width: 230,
    renderCell: (params) => {
      const fileUrl = params.value;
      const isPDF = fileUrl?.toLowerCase().endsWith(".pdf");

      return (
        <div className="cellWithImg">
          {isPDF ? (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <img
                src="/images/pdf_icon.png" // Replace with your PDF icon path
                alt="PDF"
                style={{ width: "24px", height: "24px" }}
              />
              <span>{fileUrl.split("/").pop()}</span>
            </div>
          ) : (
            <img src={fileUrl} alt="Marksheet" className="cellImg" />
          )}
        </div>
      );
    },
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchStudentRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    // role: 'coo',
    // role_id: '2',
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/student`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};

// Export an empty array to be used until the API data is loaded
export const studentRows = [];

/**
 * late form
 */
export const lformColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "user_names",
    headerName: "User",
    width: 230,
  },
  {
    field: "reason",
    headerName: "Reason For Latness",
    width: 230,
  },
  {
    field: "time",
    headerName: "Late Time",
    width: 230,
  },
  {
    field: "date",
    headerName: "Date",
    width: 230,
  },

  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchLformRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    student_id: localStorage.getItem("student_id"),
    // role: 'coo',
    // role_id: '2',
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/student/lform`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};

// Export an empty array to be used until the API data is loaded
export const lformRows = [];

/**
 * late form
 */
export const timetableColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "teacher_name",
    headerName: "Teacher",
    width: 230,
  },
  {
    field: "class_name",
    headerName: "Class",
    width: 230,
  },
  {
    field: "subject_name",
    headerName: "Subject",
    width: 230,
  },
  {
    field: "day",
    headerName: "Day",
    width: 230,
  },
  {
    field: "start_slot_time",
    headerName: "Start Time",
    width: 230,
  },
  {
    field: "end_slot_time",
    headerName: "End Time",
    width: 230,
  },
];
// Fetch the data from the API and format it for the DataGrid
// Fetch the data from the API and format it for the DataGrid
export const fetchTimetableRows = async (timeTableMasterId) => {
  try {
    const response = await fetch(
      `${serverUrl}/timetableByMaster/${timeTableMasterId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Error: " + response.status);
    }

    const data = await response.json();
    console.log("Fetched timetable by master:", data);
    return data;
  } catch (error) {
    console.error("Error fetching timetable by master:", error);
  }
};

// Export an empty array to be used until the API data is loaded
export const timetableRows = [];

// ================= Timetable Master ===================
export const timetableMasterColumns = [
  // { field: "id", headerName: "ID", width: 70 },
  {
    field: "name",
    headerName: "Name",
    width: 230,
  },
  {
    field: "class_name",
    headerName: "Class",
    width: 80,
  },
  {
    field: "month",
    headerName: "Month",
    width: 150,
    renderCell: (params) => {
      if (!params.value) return "";
      const [year, month] = params.value.split("-");
      const monthName = new Date(`${year}-${month}-01`).toLocaleString(
        "default",
        { month: "long" }
      );
      return `${monthName} ${year}`;
    },
  },
  {
    field: "is_active",
    headerName: "Active",
    width: 80,
    renderCell: (params) => {
      return params.value ? (
        <div className="flex items-center gap-2">
          <span className="w-2.5 h-2.5 rounded-full bg-green-500"></span>
          <span className="text-green-600 font-medium">Yes</span>
        </div>
      ) : (
        <span className="text-gray-500">No</span>
      );
    },
  },
  {
    field: "slots_progress",
    headerName: "Slots",
    width: 150,
    renderCell: (params) => {
      const totalSlots = params.row.slot_progress || 0;
      const remaining = 30 - totalSlots;
      return totalSlots >= 30 ? (
        <span className="text-green-600 font-medium">
          Completed ({totalSlots}/30)
        </span>
      ) : (
        <span className="text-red-500 font-medium">
          {remaining} Remaining ({totalSlots}/30)
        </span>
      );
    },
  },
  {
    field: "is_upcoming",
    headerName: "Upcoming",
    width: 100,
    renderCell: (params) => {
      return params.value ? (
        <div className="flex items-center gap-2">
          <span className="w-2.5 h-2.5 rounded-full bg-yellow-500"></span>
          <span className="text-yellow-600 font-medium">Upcoming</span>
        </div>
      ) : (
        <span className="text-gray-500">No</span>
      );
    },
  },
  {
    field: "effective_from",
    headerName: "Effective From",
    width: 150,
    renderCell: (params) => {
      if (!params.value) return "-";
      const date = new Date(params.value);
      return date.toLocaleDateString("en-US", {
        weekday: "short",
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    },
  },
  {
    field: "effective_to",
    headerName: "Effective To",
    width: 150,
    renderCell: (params) => {
      if (!params.value) return "-";
      const date = new Date(params.value);
      return date.toLocaleDateString("en-US", {
        weekday: "short",
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    },
  },
];

export const fetchTimetableMasterRows = async () => {
  try {
    const response = await fetch(
      `${serverUrl}/timetable_master?center_id=${localStorage.getItem(
        "center_id"
      )}&role_id=${localStorage.getItem(
        "role_id"
      )}&class_id=${localStorage.getItem("class_id")}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Error: " + response.status);
    }

    const data = await response.json();
    const derivedData = data.data.map((row) => ({
      ...row,
      is_upcoming: row.effective_from === null && row.effective_to === null,
      is_active: row.effective_from !== null && row.effective_to === null,
    }));
    return { code: data.code, status: data.status, data: derivedData };
  } catch (error) {
    console.error("Error fetching timetable master:", error);
    return { data: [] };
  }
};

// Export empty rows until API data is loaded
export const timetableMasterRows = [];

export const monthlyresultColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "class_name",
    headerName: "Class",
    width: 230,
  },
  {
    field: "month",
    headerName: "Month",
    width: 230,
  },
  {
    field: "exam_type",
    headerName: "Exam Type",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchMonthlyresultRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),

    // role: 'coo',
    // role_id: '2',
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/monthly_results`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};

// Export an empty array to be used until the API data is loaded
export const monthlyresultRows = [];

/**
 * Teacher Attendance form
 */
export const teacherattendanceColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "teacher_name",
    headerName: "Teacher",
    width: 230,
  },
  {
    field: "class_name",
    headerName: "Class",
    width: 230,
  },
  {
    field: "subject_name",
    headerName: "Subject",
    width: 230,
  },
  {
    field: "day",
    headerName: "Day",
    width: 230,
  },
  {
    field: "attendance_date",
    headerName: "Date",
    width: 230,
  },
  {
    field: "start_slot_time",
    headerName: "Start Time",
    width: 230,
  },
  {
    field: "end_slot_time",
    headerName: "End Time",
    width: 230,
  },
  {
    field: "status",
    headerName: "Teacher Status",
    width: 230,
  },
  {
    field: "user_rep_name",
    headerName: "Teacher Replacement",
    width: 230,
  },
  {
    field: "subject_rep_name",
    headerName: "Subject Replacement",
    width: 230,
  },

  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
// export const fetchTeacherattendanceRows = async () => {
//   const formData = {
//     center_id: localStorage.getItem("center_id"),
//     // role: 'coo',
//     // role_id: '2',
//   };
//   console.log("abbas", formData);
//   const formDataString = JSON.stringify(formData);
//   try {
//     const response = await fetch(`${serverUrl}/teacher_attendance`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: formDataString,
//     })
//       .then((response) => {
//         if (response.ok) {
//           return response.json();
//         } else {
//           throw new Error("Error: " + response.status);
//         }
//       })
//       .then((data) => {
//         const userdata = data;
//         console.log("abbas", userdata);
//         return userdata;
//       })
//       .catch((error) => {
//         console.log(error);
//         // setError('Invalid username or password!');
//         // setUsername('');
//         // setPassword('');
//       });
//     return response;
//   } catch (error) {
//     console.error(error);
//   }
// };

export const fetchTeacherattendanceRows = async (params) => {
  const today = new Date().toISOString().split("T")[0];
  const formData = {
    center_id: params.center_id || "1",
    page: params.page || 1,
    limit: params.limit || 5,
    class_id: params.class_id || null,
    teacher_id: params.teacher_id || null,
    date_from: params.date_from || null,
    date_to:
      params.date_to !== undefined
        ? params.date_to
        : params.date_from
        ? today
        : null,
  };

  try {
    const response = await fetch(`${serverUrl}/teacher_attendance_new`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (!response.ok) throw new Error(`Error: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};

// Export an empty array to be used until the API data is loaded
export const teacherattendanceRows = [];
/**
 * Teacher Attendance form
 */
export const InvigilationattendanceColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "teacher_name",
    headerName: "Teacher",
    width: 230,
  },
  {
    field: "date",
    headerName: "Date",
    width: 230,
  },
  {
    field: "duty_time",
    headerName: "Time",
    width: 230,
  },
  {
    field: "teacher_status",
    headerName: "Teacher Status",
    width: 230,
  },
  {
    field: "user_rep_name",
    headerName: "Invigilator Replacement",
    width: 230,
  },
  // {
  //   field: "subject_rep_name",
  //   headerName: "Subject Replacement",
  //   width: 230,
  // },

  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchInvigilationattendanceRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    // role: 'coo',
    // role_id: '2',
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/invagilation_attendance`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};

// Export an empty array to be used until the API data is loaded
export const InvigilationattendanceRows = [];

/**
 * Teacher Attendance form
 */
export const sawardlistColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "name",
    headerName: "Student Name",
    width: 230,
  },
  {
    field: "class_name",
    headerName: "Class",
    width: 230,
  },
  {
    field: "roll_number",
    headerName: "Role Number",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchSAwardlistRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    class_id: localStorage.getItem("Aclass_id"),
    // role: 'coo',
    // role_id: '2',
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/student_awardlist`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};

// Export an empty array to be used until the API data is loaded
export const sawardlistRows = [];

export const fetchAwardlistRows = () => {
  const formData = {
    student_id: localStorage.getItem("student_id_n"),
    examination_id: localStorage.getItem("examination_id"),
    // role: 'coo',
    // role_id: '2',
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = fetch(`${serverUrl}/awardlist_for_checking`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};

/**
 * leave form
 */
export const leaveformColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "leave_file_url", // Use the URL field from your API response
    headerName: "Leave Form",
    width: 230,
    renderCell: (params) => {
      const fileUrl = params.value;

      // Handle empty or undefined URLs
      if (!fileUrl) {
        return (
          <div
            className="cellWithImg"
            style={{ color: "#999", padding: "8px" }}
          >
            No file attached
          </div>
        );
      }

      // Extract filename safely
      const filename = fileUrl.split("/").pop() || "document";
      const isPDF = filename.toLowerCase().endsWith(".pdf");
      const isImage = [".jpg", ".jpeg", ".png"].some((ext) =>
        filename.toLowerCase().endsWith(ext)
      );

      return (
        <div className="cellWithImg">
          {isPDF ? (
            <a
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <img
                src="/images/pdf_icon.png"
                alt="PDF"
                style={{ width: "24px", height: "24px" }}
              />
              <span>{filename}</span>
            </a>
          ) : isImage ? (
            <a
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "block" }}
            >
              <img
                src={fileUrl}
                alt="Leave Form"
                className="cellImg"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/file_error.png";
                }}
              />
            </a>
          ) : (
            <a
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <img
                src="/images/file_icon.png"
                alt="File"
                style={{ width: "24px", height: "24px" }}
              />
              <span>{filename}</span>
            </a>
          )}
        </div>
      );
    },
  },
  {
    field: "user_names",
    headerName: "Teacher",
    width: 230,
  },
  {
    field: "reason",
    headerName: "Reason For Leave",
    width: 230,
  },
  {
    field: "start_date_time",
    headerName: "From Date",
    width: 230,
  },
  {
    field: "end_date_time",
    headerName: "to Date",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchLeaveformRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    student_id: localStorage.getItem("student_id"),
    type: 1,
    // role: 'coo',
    // role_id: '2',
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/student/leave_form`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
export const leaveformRows = [];

/**
 * leave form
 */
export const halfleaveformColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "leave_file_url", // Use the URL field from your API response
    headerName: "Leave Form",
    width: 230,
    renderCell: (params) => {
      const fileUrl = params.value;

      // Handle empty or undefined URLs
      if (!fileUrl) {
        return (
          <div
            className="cellWithImg"
            style={{ color: "#999", padding: "8px" }}
          >
            No file attached
          </div>
        );
      }

      // Extract filename safely
      const filename = fileUrl.split("/").pop() || "document";
      const isPDF = filename.toLowerCase().endsWith(".pdf");
      const isImage = [".jpg", ".jpeg", ".png"].some((ext) =>
        filename.toLowerCase().endsWith(ext)
      );

      return (
        <div className="cellWithImg">
          {isPDF ? (
            <a
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <img
                src="/images/pdf_icon.png"
                alt="PDF"
                style={{ width: "24px", height: "24px" }}
              />
              <span>{filename}</span>
            </a>
          ) : isImage ? (
            <a
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "block" }}
            >
              <img
                src={fileUrl}
                alt="Leave Form"
                className="cellImg"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/file_error.png";
                }}
              />
            </a>
          ) : (
            <a
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <img
                src="/images/file_icon.png"
                alt="File"
                style={{ width: "24px", height: "24px" }}
              />
              <span>{filename}</span>
            </a>
          )}
        </div>
      );
    },
  },
  {
    field: "user_names",
    headerName: "Teacher",
    width: 230,
  },
  {
    field: "reason",
    headerName: "Reason For Leave",
    width: 230,
  },
  {
    field: "start_date_time",
    headerName: "From Date",
    width: 230,
  },
  {
    field: "end_date_time",
    headerName: "to Date",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchHalfleaveformRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    student_id: localStorage.getItem("student_id"),
    type: 0,
    // role: 'coo',
    // role_id: '2',
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/student/leave_form`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
export const halfleaveformRows = [];

/**
 * Absent form
 */
export const absentformColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "absent_file_url", // Changed to match your API response field name
    headerName: "Application For Absent",
    width: 230,
    renderCell: (params) => {
      const fileUrl = params.value;

      // Handle empty or undefined URLs
      if (!fileUrl) {
        return (
          <div className="cellWithImg" style={{ color: "#999" }}>
            No file attached
          </div>
        );
      }

      // Extract filename safely
      const filename = fileUrl.split("/").pop() || "document";
      const isPDF = filename.toLowerCase().endsWith(".pdf");
      const isImage = [".jpg", ".jpeg", ".png"].some((ext) =>
        filename.toLowerCase().endsWith(ext)
      );

      return (
        <div className="cellWithImg">
          {isPDF ? (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <img
                src="/images/pdf_icon.png"
                alt="PDF"
                style={{ width: "24px", height: "24px" }}
              />
              <a
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {filename}
              </a>
            </div>
          ) : isImage ? (
            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
              <img
                src={fileUrl}
                alt="Application"
                className="cellImg"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/file_error.png";
                }}
              />
            </a>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <img
                src="/images/file_icon.png"
                alt="File"
                style={{ width: "24px", height: "24px" }}
              />
              <a
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {filename}
              </a>
            </div>
          )}
        </div>
      );
    },
  },
  {
    field: "user_names",
    headerName: "Teacher",
    width: 230,
  },
  {
    field: "reason",
    headerName: "Reason For Absent",
    width: 230,
  },
  {
    field: "date",
    headerName: "Date",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchAbsentformRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    student_id: localStorage.getItem("student_id"),

    // role: 'coo',
    // role_id: '2',
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/student/Aform`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};

// Export an empty array to be used until the API data is loaded
export const absentformRows = [];

/**
 * Subject
 */
export const subjectColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "name",
    headerName: "Subject Name",
    width: 230,
  },
  // {
  //   field: "class_names",
  //   headerName: "Class",
  //   width: 230,
  // },
  // {
  //   field: "user_names",
  //   headerName: "Users",
  //   width: 230,
  // },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchSubjectRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    // role: 'coo',
    // role_id: '2',
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/subject`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const subjectRows = [];
/**
 * Subject
 */
// export const studentattendanceColumns = [
//   { field: "id", headerName: "ID", width: 70 },
//   // {
//   //   field: "center_id",
//   //   headerName: "Center Id",
//   //   width: 230,
//   // },
//   {
//     field: "student_name",
//     headerName: "Student Name",
//     width: 230,
//   },
//   {
//     field: "attendance_date",
//     headerName: "Date",
//     width: 230,
//   },
//   {
//     field: "class_name",
//     headerName: "Class",
//     width: 230,
//   },
//   {
//     field: "user_name",
//     headerName: "Teacher",
//     width: 230,
//   },
//   {
//     field: "admin_name",
//     headerName: "Admin",
//     width: 230,
//   },
//   {
//     field: "subject_name",
//     headerName: "Subject",
//     width: 230,
//   },
//   {
//     field: "status",
//     headerName: "Status",
//     width: 120,
//     renderCell: (params) => {
//       const statusMap = {
//         0: { text: "Absent", color: "#ff4d4f" }, // red
//         1: { text: "Present", color: "#52c41a" }, // green
//         2: { text: "Late", color: "#faad14" }, // orange
//         3: { text: "Leave", color: "#1890ff" }, // blue
//         4: { text: "Half Leave", color: "#1900ff" }, // blue
//       };
//       const status = statusMap[params.value] || {
//         text: "Unknown",
//         color: "#d9d9d9",
//       };

//       return (
//         <div
//           style={{
//             color: status.color,
//             fontWeight: "bold",
//             display: "inline-flex",
//             alignItems: "center",
//           }}
//         >
//           <span
//             style={{
//               display: "inline-block",
//               width: "10px",
//               height: "10px",
//               borderRadius: "50%",
//               backgroundColor: status.color,
//               marginRight: "8px",
//             }}
//           ></span>
//           {status.text}
//         </div>
//       );
//     },
//   },
// ];

// // Fetch the data from the API and format it for the DataGrid
// export const fetchStudentattendanceRows = async () => {
//   const formData = {
//     center_id: localStorage.getItem("center_id"),
//     // role: 'coo',
//     // role_id: '2',
//   };
//   console.log("abbas", formData);
//   const formDataString = JSON.stringify(formData);
//   try {
//     const response = await fetch(`${serverUrl}/student_attendance`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: formDataString,
//     })
//       .then((response) => {
//         if (response.ok) {
//           return response.json();
//         } else {
//           throw new Error("Error: " + response.status);
//         }
//       })
//       .then((data) => {
//         const userdata = data;
//         console.log("abbas", userdata);
//         return userdata;
//       })
//       .catch((error) => {
//         console.log(error);
//         // setError('Invalid username or password!');
//         // setUsername('');
//         // setPassword('');
//       });
//     return response;
//   } catch (error) {
//     console.error(error);
//   }
// };
// // Export an empty array to be used until the API data is loaded
// export const studentattendanceRows = [];

export const studentattendanceColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "student_name",
    headerName: "Student Name",
    width: 230,
  },
  {
    field: "attendance_date",
    headerName: "Date",
    width: 230,
  },
  {
    field: "class_name",
    headerName: "Class",
    width: 230,
  },
  {
    field: "user_name",
    headerName: "Teacher",
    width: 230,
  },
  {
    field: "admin_name",
    headerName: "Admin",
    width: 230,
  },
  {
    field: "subject_name",
    headerName: "Subject",
    width: 230,
  },
  {
    field: "status",
    headerName: "Status",
    width: 120,
    renderCell: (params) => {
      const statusMap = {
        0: { text: "Absent", color: "#ff4d4f" },
        1: { text: "Present", color: "#52c41a" },
        2: { text: "Late", color: "#faad14" },
        3: { text: "Leave", color: "#1890ff" },
        4: { text: "Half Leave", color: "#1900ff" },
      };
      const status = statusMap[params.value] || {
        text: "Unknown",
        color: "#d9d9d9",
      };

      return (
        <div
          style={{
            color: status.color,
            fontWeight: "bold",
            display: "inline-flex",
            alignItems: "center",
          }}
        >
          <span
            style={{
              display: "inline-block",
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: status.color,
              marginRight: "8px",
            }}
          ></span>
          {status.text}
        </div>
      );
    },
  },
];

export const fetchStudentattendanceRows = async (params) => {
  const today = new Date().toISOString().split("T")[0];
  // Set date_to to today only if date_from is provided and date_to is not explicitly set
  const formData = {
    center_id: params.center_id || "1",
    page: params.page || 1,
    limit: params.limit || 5,
    class_id: params.class_id || null, // Use null instead of undefined for consistency
    student_id: params.student_id || null,
    date_from: params.date_from || null,
    date_to:
      params.date_to !== undefined
        ? params.date_to
        : params.date_from
        ? today
        : null,
  };

  try {
    const response = await fetch(`${serverUrl}/student_attendance_new`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};

export const studentattendanceRows = [];

/**
 * Teacher
 */
export const teacherColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "user_names",
    headerName: "Teacher",
    width: 230,
  },
  {
    field: "class_names",
    headerName: "Class",
    width: 230,
  },
  {
    field: "subject_names",
    headerName: "Subject",
    width: 230,
  },

  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchTeacherRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    role: "teacher",
    role_id: localStorage.getItem("role_id"),
    teacher_id: localStorage.getItem("teacher_id"),
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/teacher`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const teacherRows = [];

/**
 * result
 */
export const resultColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "center_id",
    headerName: "Center Id",
    width: 230,
  },
  {
    field: "exam_id",
    headerName: "Exam Id",
    width: 230,
  },
  {
    field: "student_id",
    headerName: "Student Id",
    width: 230,
  },
  {
    field: "mark",
    headerName: "Marks",
    width: 230,
  },
  {
    field: "status",
    headerName: "Status",
    width: 160,
    renderCell: (params) => {
      return (
        <div className={`cellWithStatus ${params.row.status}`}>
          {params.row.status}
        </div>
      );
    },
  },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchResultRows = async () => {
  try {
    const apiUrl = `${serverUrl}/result`;
    const response = await fetch(apiUrl);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const resultRows = [];

/**
 * role
 */
export const roleColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "name",
    headerName: "Name",
    width: 230,
  },
  {
    field: "screen_names",
    headerName: "Screen",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchRoleRows = async () => {
  try {
    const apiUrl = `${serverUrl}/role`;
    const response = await fetch(apiUrl);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const roleRows = [];

/**
 * Center
 */
export const centerColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "name",
    headerName: "Center Name",
    width: 230,
  },
  {
    field: "logo_url",
    headerName: "Picture",
    width: 230,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <img src={params.value} alt="Profile" className="cellImg" />
        </div>
      );
    },
  },
  {
    field: "address",
    headerName: "Address",
    width: 230,
  },
  {
    field: "phone_no",
    headerName: "Phone Number",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchCenterRows = async () => {
  try {
    const apiUrl = `${serverUrl}/center`;
    const response = await fetch(apiUrl);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
};

// Export an empty array to be used until the API data is loaded
export const centerRows = [];

/**
 * Role Screen
 */
export const rolescreenColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "name",
    headerName: "Screen Name",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchRolescreenRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/rscreen`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const rolescreenRows = [];

/**
 * Examination
 */
export const examinationColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "file_url",
    headerName: "Paper",
    width: 230,
    renderCell: (params) => {
      const fileUrl = params.value;
      const isPDF = fileUrl?.toLowerCase().endsWith(".pdf");

      return (
        <div
          className="cellWithImg"
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          {isPDF ? (
            <>
              <img
                src="/images/pdf_icon.png" // Replace with actual path to your PDF icon
                alt="PDF"
                style={{ width: "24px", height: "24px" }}
              />
              <span>{fileUrl?.split("/").pop()}</span>
            </>
          ) : (
            <img
              src={fileUrl}
              alt="B Form"
              className="cellImg"
              style={{
                width: "40px",
                height: "40px",
                objectFit: "cover",
                borderRadius: "4px",
              }}
            />
          )}
        </div>
      );
    },
  },
  {
    field: "class_names",
    headerName: "Class",
    width: 230,
  },
  {
    field: "subject_names",
    headerName: "Subject",
    width: 230,
  },
  {
    field: "type",
    headerName: "Paper Type",
    width: 230,
  },
  {
    field: "month",
    headerName: "Month",
    width: 230,
  },
  {
    field: "date",
    headerName: "Date",
    type: "date",
    width: 230,
  },
  {
    field: "total_marks",
    headerName: "Total Marks",
    width: 230,
  },
  {
    field: "user_names",
    headerName: "Invigilator",
    width: 230,
  },
  {
    field: "schedule_start_time",
    headerName: "Schedule Start Time",
    width: 230,
  },
  {
    field: "schedule_end_time",
    headerName: "Schedule End Time",
    width: 230,
  },
  {
    field: "start_time",
    headerName: "Start Time",
    width: 230,
  },
  {
    field: "end_time",
    headerName: "End Time",
    width: 230,
  },
  {
    field: "duration",
    headerName: "Duration",
    width: 230,
  },
  {
    field: "checking_status",
    headerName: "Checking Status",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchExaminationRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    role: "user",
    user_id: localStorage.getItem("user_id"),
    role_id: localStorage.getItem("role_id"),
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/examination`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const examinationRows = [];

export const feesformColumns = [
  { field: "id", headerName: "ID", width: 70 },
  // {
  //   field: "center_id",
  //   headerName: "Center Id",
  //   width: 230,
  // },
  {
    field: "slip_image_url",
    headerName: "Slip Image",
    width: 230,
    renderCell: (params) => {
      const fileUrl = params.value;
      const isPDF = fileUrl?.toLowerCase().endsWith(".pdf");

      return (
        <div
          className="cellWithImg"
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          {isPDF ? (
            <>
              <img
                src="/images/pdf_icon.png" // Replace with actual path to your PDF icon
                alt="PDF"
                style={{ width: "24px", height: "24px" }}
              />
              <span>{fileUrl?.split("/").pop()}</span>
            </>
          ) : (
            <img
              src={fileUrl}
              alt="B Form"
              className="cellImg"
              style={{
                width: "40px",
                height: "40px",
                objectFit: "cover",
                borderRadius: "4px",
              }}
            />
          )}
        </div>
      );
    },
  },
  {
    field: "user_names",
    headerName: "Person Who Fill The Recipet",
    width: 230,
  },
  {
    field: "student_name",
    headerName: "Student",
    width: 230,
  },
  {
    field: "account_name",
    headerName: "Account",
    width: 230,
  },
  {
    field: "amount",
    headerName: "Amount",
    width: 230,
  },
  {
    field: "date",
    headerName: "Date",
    type: "date",
    width: 230,
  },
  {
    field: "amount_type",
    headerName: "Amount Type",
    width: 230,
  },
  {
    field: "description",
    headerName: "Description",
    width: 230,
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchFeesformRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/feesform`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const feesformRows = [];

/**
 * Course Chapter
 */
export const coursechapterColumns = [
  { field: "id", headerName: "ID", width: 70 },

  // {
  //   field: "subject_names",
  //   headerName: "Subject",
  //   width: 230,
  // },
  // {
  //   field: "class_names",
  //   headerName: "Class",
  //   width: 230,
  // },
  {
    field: "name",
    headerName: "Name",
    width: 230,
  },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchCoursechapterRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    subject_id: localStorage.getItem("selected_subject_id"),
    class_id: localStorage.getItem("selected_class_id"),
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/cchapter`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const coursechapterRows = [];

/**
 * Course Chapter
 */
export const unitColumns = [
  { field: "id", headerName: "ID", width: 70 },

  {
    field: "chapter_names",
    headerName: "Chapter",
    width: 230,
  },
  {
    field: "name",
    headerName: "Name",
    width: 230,
  },
  {
    field: "month",
    headerName: "Month in which it will be covered",
    width: 230,
  },
  {
    field: "description",
    headerName: "Description",
    width: 230,
  },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchUnitRows = async () => {
  const formData = {
    center_id: localStorage.getItem("center_id"),
    chapter_id: localStorage.getItem("chapter_id_for_unit"),
  };
  console.log("abbas", formData);
  const formDataString = JSON.stringify(formData);
  try {
    const response = await fetch(`${serverUrl}/unit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: formDataString,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Error: " + response.status);
        }
      })
      .then((data) => {
        const userdata = data;
        console.log("abbas", userdata);
        return userdata;
      })
      .catch((error) => {
        console.log(error);
        // setError('Invalid username or password!');
        // setUsername('');
        // setPassword('');
      });
    return response;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const unitRows = [];

/**
 * Categories
 */
export const categoryColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "category_name",
    headerName: "Category",
    width: 230,
  },
  {
    field: "category_picture",
    headerName: "Picture",
    width: 230,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <img src={params.value} alt="Profile" className="cellImg" />
        </div>
      );
    },
  },

  {
    field: "no_of_quiz",
    headerName: "Number of Quiz",
    width: 230,
  },
  {
    field: "status",
    headerName: "Status",
    width: 160,
    renderCell: (params) => {
      return (
        <div className={`cellWithStatus ${params.row.status}`}>
          {params.row.status}
        </div>
      );
    },
  },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchCategoryRows = async () => {
  try {
    const apiUrl = "/center";
    const response = await fetch(apiUrl);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const categoryRows = [
  {
    id: 1,
    category_name: "Biology and Scientific Method",
    category_picture:
      "file:///C:/Users/Muhammad%20Jawwad/Downloads/undraw_doctors_7fdn%20(1).svg",
    no_of_quiz: 20,
    status: 1,
    created_at: "2022-11-21T14:00:12.000Z",
    updated_at: "2022-11-21T14:00:12.000Z",
  },
  {
    id: 2,
    category_name: "Arts and Sciences",
    category_picture:
      "file:///C:/Users/Muhammad%20Jawwad/Downloads/undraw_doctors_7fdn%20(1).svg",
    no_of_quiz: 10,
    status: 1,
    created_at: "2022-11-21T14:02:08.000Z",
    updated_at: "2022-11-21T14:02:08.000Z",
  },
  {
    id: 3,
    category_name: "Investment and Types",
    category_picture:
      "file:///C:/Users/Muhammad%20Jawwad/Downloads/undraw_business_plan_re_0v81.svg",
    no_of_quiz: 10,
    status: 1,
    created_at: "2022-11-21T14:03:18.000Z",
    updated_at: "2022-11-21T14:03:18.000Z",
  },
  {
    id: 4,
    category_name: "Art and Painting Basic",
    category_picture: "undraw_making_art_re_ee8w.svg",
    no_of_quiz: 10,
    status: 1,
    created_at: "2022-11-21T14:04:45.000Z",
    updated_at: "2022-11-21T14:04:45.000Z",
  },
];

/**
 * Quizes
 */
export const quizColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "quiz_no",
    headerName: "Quiz Number",
    width: 230,
  },
  {
    field: "category_id",
    headerName: "Category Id",
    width: 230,
  },
  {
    field: "quiz_name",
    headerName: "Quiz Name",
    width: 230,
  },
  {
    field: "picture",
    headerName: "Picture",
    width: 230,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <img src={params.value} alt="Profile" className="cellImg" />
        </div>
      );
    },
  },
  {
    field: "no_of_questions",
    headerName: "Number of Questions",
    width: 230,
  },
  {
    field: "description",
    headerName: "Description",
    width: 230,
  },
  {
    field: "status",
    headerName: "Status",
    width: 160,
    renderCell: (params) => {
      return (
        <div className={`cellWithStatus ${params.row.status}`}>
          {params.row.status}
        </div>
      );
    },
  },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchQuizRows = async () => {
  try {
    const apiUrl = "/api/admin/getquiz";
    const response = await fetch(apiUrl);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const quizRows = [];

/**
 * Questions
 */
export const questionColumns = [
  { field: "id", headerName: "ID", width: 70 },
  {
    field: "quiz_id",
    headerName: "Quiz Id",
    width: 230,
  },
  {
    field: "question",
    headerName: "Question",
    width: 230,
  },
  {
    field: "option_1",
    headerName: "Option 1",
    width: 230,
  },
  {
    field: "option_2",
    headerName: "Option 2",
    width: 230,
  },
  {
    field: "option_3",
    headerName: "Option 3",
    width: 230,
  },
  {
    field: "option_4",
    headerName: "Option 4",
    width: 230,
  },
  {
    field: "correct_option",
    headerName: "Correct Option",
    width: 230,
  },
  {
    field: "status",
    headerName: "Status",
    width: 160,
    renderCell: (params) => {
      return (
        <div className={`cellWithStatus ${params.row.status}`}>
          {params.row.status}
        </div>
      );
    },
  },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchQuestionRows = async () => {
  try {
    const apiUrl = "/api/admin/getquestion";
    const response = await fetch(apiUrl);
    console.log("response", response);
    const data = await response.json();
    console.log("data", data);
    return data;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const questionRows = [];

/**
 * Review
 */
export const reviewColumns = [
  { field: "id", headerName: "ID", width: 100 },
  {
    field: "question",
    headerName: "Question",
    width: 1180,
  },
];
// Fetch the data from the API and format it for the DataGrid
export const fetchReviewRows = async () => {
  try {
    const apiUrl = "/api/admin/getquestion";
    const response = await fetch(apiUrl);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
};
// Export an empty array to be used until the API data is loaded
export const reviewRows = [];
